var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUseReward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3273_7823)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.75703,
    y: 9.02437,
    width: 12.4,
    height: 8.5523,
    rx: 1.2,
    stroke: "#2990FB",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6523 5.67896L14.4641 11",
    stroke: "#2990FB",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2617 5.67896L9.44992 11",
    stroke: "#2990FB",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0029 5.17651C10.8853 5.17651 11.5966 5.88928 11.5967 6.76343C11.5967 7.63765 10.8854 8.35034 10.0029 8.35034C9.12062 8.35019 8.40918 7.63756 8.40918 6.76343C8.40927 5.88937 9.12068 5.17666 10.0029 5.17651Z",
    fill: "white",
    stroke: "#2990FB",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9092 5.17651C14.7916 5.17651 15.5028 5.88928 15.5029 6.76343C15.5029 7.63765 14.7916 8.35034 13.9092 8.35034C13.0269 8.35019 12.3154 7.63756 12.3154 6.76343C12.3155 5.88937 13.0269 5.17666 13.9092 5.17651Z",
    fill: "white",
    stroke: "#2990FB",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1,
    width: 1.6,
    height: 5.6,
    fill: "#2990FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4.6001,
    width: 1.6,
    height: 5.6,
    transform: "rotate(-90 1 4.6001)",
    fill: "#2990FB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.9992,
    y1: 9,
    x2: 11.9992,
    y2: 17,
    stroke: "#2990FB",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.9961,
    y1: 13.3,
    x2: 5.99609,
    y2: 13.3,
    stroke: "#2990FB",
    strokeWidth: 1.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3273_7823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseReward);
export default __webpack_public_path__ + "static/media/useReward.3461fac52a302ce446c36a84e4e9f6b9.svg";
export { ForwardRef as ReactComponent };